import FloatingCta from './floating-cta';

export default FloatingCta;
